<template>
  <div class="productCenter">
    <pageHeader
      :actNum="1"
      :bannerImg="bannerImg"
      bannerText="- Data"
      bannerText2="Become controllable"
    />
    <!-- <div class="background"></div>
    <div class="banner">
      <img :src="bannerImg" />
      <span>-我们的产品中心</span>
    </div> -->
    <div class="top">
      <div class="top-left">您的位置：<span class="homeSpan" @click="tarHome()">首页</span
      > > 我们业务</div>
      <div class="top-right">
        <span
          v-for="(item, i) in classList"
          :key="i"
          :class="{ actSpan: actNum == i }"
          @click="changClass(i)"
          >{{ item.label }}</span
        >
      </div>
    </div>
    <div class="content">
      <div
        class="content-box"
        v-for="(item, i) in showList"
        :key="i"
        @mouseover="changeHover(true, i)"
        @mouseleave="changeHover(false, i)"
        @click="tarDetail(item)"
      >
        <div class="box1" v-if="i == 0 || i == 2">
          <div class="box1-left">
            <div class="title">{{ item.title }}</div>
            <div class="title2">{{ item.title2 }}</div>
            <div class="text">{{ item.content }}</div>
            <div class="more">
              了解更多
              <img :src="icon_right2" v-if="!item.show" />
              <img :src="icon_right3" v-if="item.show" />
            </div>
          </div>
          <div class="box1-right">
            <img :src="getIconPath(item.img)" />
          </div>
        </div>
        <div class="box2" v-if="i == 1 || i == 3">
          <div class="box2-right">
            <img :src="getIconPath(item.img)" />
          </div>
          <div class="box2-left">
            <div class="title">{{ item.title }}</div>
            <div class="title2">{{ item.title2 }}</div>
            <div class="text">{{ item.content }}</div>
            <div class="more">
              了解更多
              <img :src="icon_right2" v-if="!item.show" />
              <img :src="icon_right3" v-if="item.show" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="paging">
      <div
        v-for="i in pageNum"
        :key="i"
        :class="{ actDiv: i == divNum }"
        @click="changDivNum(i)"
      >
        {{ i }}
      </div>
    </div>
    <footPage />
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader/index.vue";
import footPage from "@/components/foot/index.vue";
import bannerImg from "@/assets/img/banner_product.png";
import icon_right2 from "@/assets/img/icon_right2.png";
import icon_right3 from "@/assets/img/icon_right3.png";
export default {
  name: "productCenter",
  components: {
    pageHeader,
    footPage,
  },
  data() {
    return {
      bannerImg,
      icon_right2,
      icon_right3,
      classList: [
        { label: "全部" },
        { label: "智慧病案" },
        { label: "医疗质控" },
        { label: "DRG/DIP" },
        { label: "医疗管理" },
        { label: "数据上报" },
      ],
      actNum: 0,
      dataList: [], //全部数据
      dataList1: [
        {
          type: "1",
          num: "0",
          title: "病案统计管理系统",
          show: false,
          img: "img_product1",
          title2: "提供科学可靠的依据",
          content:
            "普康病案统计管理系统是医院信息系统建设中的重要组成部分，是集病案收集、整理、存储、查询、统计等功能于一体的医疗信息系统，涵盖了医院门诊日志、病人病案首页、医院统计报表等大量信息，不仅能反映出医院经营管理的现状和水平，也能为医院的经营管理决策提供科学可靠的依据。",
        },
        {
          type: "1",
          num: "1",
          title: "病案示踪管理系统",
          show: false,
          img: "img_product2",
          title2: "实现了病案流向管理的规范化、系统化、数字化",
          content:
            "普康病案示踪管理系统详细记载病案从回收至入库的每一环节，提供了对病案的签出、签收、内部流转、上架、入库、借阅、复印、归还等环节的管理措施，从而管理纸质病案的实时流通状态，帮助医院实现了病案流向管理的规范化、系统化.数字化。",
        },
      ],
      dataList2: [
        {
          type: "2",
          num: "0",
          title: "病案首页全流程质控系统",
          show: false,
          img: "img_product3",
          title2: "推动病案管理的标准化、体系化和规范化",
          content:
            "病案首页作为患者诊疗过程的精要，不仅是医疗信息的基础来源，更是医院医疗水平与质量的重要体现。加强病案质控，不仅能显著提升医疗服务的品质，还是预防医疗纠纷的关键措施。普康病案首页质控系统致力于从多个维度，包括完整性、合理性和规范性等，对病案首页的填写质量进行持续的优化和改进。通过这种方式，系统有效降低了病案的缺陷率，推动了病案管理的标准化、体系化和规范化，实现了全面的闭环管理。",
        },
        {
          type: "2",
          num: "1",
          title: "AI电子病历质控系统",
          show: false,
          img: "img_product4",
          title2: "为医疗安全提供有力保障",
          content:
            "普康AI电子病历质控系统是一款利用人工智能技术对电子病历进行质量控制的系统。基于知识图谱与强大的自然语言处理等技术，对电子病历的完整性、准确性、规范性等进行全面检测和评估，以提高病历质量，为医疗安全提供有力保障。",
        },
        {
          type: "2",
          num: "2",
          title: "医保结算清单质控系统",
          show: false,
          img: "img_product5",
          title2: "提供了严密的监控机制",
          content:
            "普康医保结算清单质控系统是一款高效的管理系统，专注于提高医保结算清单的质量和准确性。该系统凭借其内置丰富的质控规则库，连通了从数据采集、清单编制、质量监控、审核到上报的所有服务模块，全面覆盖了院内的医保结算清单管理流程。不仅为医院提供了全面的管理工具，还为医保清单提供了严密的监控机制。",
        },
      ],
      dataList3: [
        {
          type: "3",
          num: "0",
          title: "DRG运营监管系统",
          show: false,
          img: "img_product6",
          title2: "提供全面的数据支持和决策依据",
          content:
            "普康DRG运营监管系统是一款实时监控系统，致力于医保在院运行管理。通过全程监控患者入院至出院的费用和入组情况该系统可确保医保资金有效使用和患者的合理权益。与HIS或电子病历系统集成，为医院提供全面的数据支持和决策依据。",
        },
        {
          type: "3",
          num: "1",
          title: "DIP管理系统",
          show: false,
          img: "img_product7",
          title2: "实现预期医保支付效果",
          content:
            "普康DIP运营监管系统致力于精准把控医疗成本，优化病种结构。通过全面的在院运行监管、医保费用盈亏分析及异常费用预警，助力医院提升医疗能力，实现预期医保支付效果。",
        },
      ],
      dataList4: [
        {
          type: "4",
          num: "0",
          title: "单病种质控管理系统",
          show: false,
          img: "img_product8",
          title2: "助力医院提升单病种质量管理水平",
          content:
            "普康单病种质量管理系统致力于对单病种进行集中管理、质量控制和数据上报。通过自动化的数据采集和统计分析，该系统能够确保医院单病种质量控制指标的准确性和可靠性，从而为医院提供有力的数据支撑，助力医院提升单病种质量管理水平。",
        },
        {
          type: "4",
          num: "1",
          title: "核心指标分析系统",
          show: false,
          img: "img_product9",
          title2: "指标全流程、一体化",
          content:
            "普康核心指标分析系统是一款涵盖指标定义、指标建模、指标固化、指标可视化分析，实现指标全流程、一体化管理的软件产品，可灵活配置可视化指标反馈图表，支持报表、看板、刊报等多个生成展示方式，采用全拖拽式的配置方法，步骤简单、界面清晰，医院人员轻松驾驭。",
        },
        {
          type: "4",
          num: "2",
          title: "公立医院绩效管理系统",
          show: false,
          img: "img_product10",
          title2: "为可持续发展提供有力支持",
          content:
            "普康公立医院绩效管理系统，依据国家卫生健康委公立医院绩效考核上报数据要求，致力于实现上报数据的自动采集与上报，从而显著减少手工工作量，提升工作效率。该系统不仅仅局限于数据采集和上报，更针对绩效考核的各项指标标准进行深入的多维分析。通过先进的数据分析技术，该系统能够帮助医院提升运营和质量管理能力，为其可持续发展提供有力支持。",
        },
        {
          type: "4",
          num: "3",
          title: "医院等级评审",
          show: false,
          img: "img_product11",
          title2: "等级评审提供全面的支持",
          content:
            " 普康医院等级评审系统专注于从医院的功能与任务、规模与运营管理，以及医疗质量与技术水平三大维度出发，为医院等级评审提供全面的支持。该系统能够实现快速的数据采集、整理、分析、存储及管理，确保数据的准确性和完整性。通过灵活的配置，系统能够生成各种可视化指标反馈图表，帮助评审专家直观地了解医院运营状况。",
        },
      ],
      dataList5: [
        {
          type: "5",
          num: "0",
          title: "配置化数据上报集成系统",
          img: "img_product12",
          title2: "高效、灵活、可扩展的数据集成上报解决方案",
          content:
            "普康配置化数据上报集成系统是一种高效、灵活、可扩展的数据集成上报解决方案，将上报平台集成到一起统一管理，采用配置化的方式快速地将不同来源的数据进行整合、清洗、转换和上报。",
        },
      ],
      pageNum: 0, //分页数
      divNum: 1, //当前页
      showList: [], //展示数据
    };
  },
  methods: {
    changClass(i) {
      this.actNum = i;
      if (i != 0) {
        this.showList = this["dataList" + i];
        this.pageNum = 1;
        this.divNum = 1;
      } else {
        this.init();
      }
    },
    init() {
      this.pageNum = Math.ceil(this.dataList.length / 4);
      this.changDivNum(1);
    },
    changeHover(val, i) {
      this.showList[i].show = val;
    },
    changDivNum(i) {
      // let data = this.dataList
      this.divNum = i;
      this.showList = [];
      this.dataList.forEach((item, index) => {
        if (index >= (i - 1) * 4 && index < i * 4) {
          this.showList.push(item);
        }
      });
      window.scrollTo(0, 0);
      // this.showList = data.splice((i-1)*4,i*4)
    },
    // 图片拼接
    getIconPath(iconName) {
      return require(`@/assets/img/${iconName}.png`);
    },
    tarDetail(item) {
      this.$router.push({
        path: "/productDetail",
        query: { type: item.type, num: item.num },
      });
    },
    tarHome(){
      this.$router.push('/')
    },
  },
  created() {
    this.dataList = this.dataList
      .concat(this.dataList1)
      .concat(this.dataList2)
      .concat(this.dataList3)
      .concat(this.dataList4)
      .concat(this.dataList5);
    this.pageNum = Math.ceil(this.dataList.length / 4);
    this.changDivNum(1);
  },
};
</script>

<style lang="scss" scoped>
.productCenter {
  position: relative;
  color: #333;
  .background {
    margin-top: 90px;
    background-color: #004f6a;
    width: 100%;
    height: 300px;
  }
  .banner {
    margin: 0 auto;
    width: 1544px;
    height: 400px;
    margin-top: -210px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    span {
      position: absolute;
      top: 200px;
      left: 70px;
      font-size: 18px;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding: 52px 260px;
    &-left {
      font-size: 15px;
    }
    &-right {
      span {
        font-size: 15px;
        margin-left: 28px;
        cursor: pointer;
      }
      .actSpan {
        color: #004f6a;
      }
    }
  }
  .content {
    padding: 0 260px;
    &-box {
      margin: 50px 0 168px 0;
      cursor: pointer;
      .box1 {
        display: flex;
        // justify-content: space-between;
        &-left {
          width: 505px;
          margin-right: 196px;
          .title {
            margin-top: 74px;
            font-size: 30px;
          }
          .title2 {
            font-size: 18px;
            margin-top: 10px;
          }
          .text {
            font-size: 15px;
            color: #666;
            line-height: 28px;
            margin-top: 35px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .more {
            font-size: 15px;
            margin-top: 68px;
            img {
              margin-left: 5px;
              width: 12px;
              height: 12px;
            }
          }
        }
        &-right {
          width: 700px;
          height: 438px;
          img {
            width: 100%;
            height: 100%;
            box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.2);
          }
        }
      }
      .box2 {
        display: flex;
        // justify-content: space-between;
        &-left {
          width: 505px;
          .title {
            margin-top: 74px;
            font-size: 30px;
          }
          .title2 {
            font-size: 18px;
            margin-top: 10px;
          }
          .text {
            font-size: 15px;
            color: #666;
            line-height: 28px;
            margin-top: 35px;
          }
          .more {
            font-size: 15px;
            margin-top: 68px;
            img {
              margin-left: 5px;
              width: 12px;
              height: 12px;
            }
          }
        }
        &-right {
          width: 700px;
          height: 438px;
          margin-right: 196px;
          img {
            width: 100%;
            height: 100%;
            box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
    &-box:hover {
      .title,
      .more {
        color: #004f6a;
      }
    }
  }
  .paging {
    padding: 0 260px 175px 260px;
    display: flex;
    div {
      width: 42px;
      height: 42px;
      border: 1px solid #dcdcdc;
      line-height: 42px;
      text-align: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .actDiv {
      background-color: #004f6a;
      color: #fff;
      border: 1px solid #004f6a;
    }
  }
}
</style>